export type CpnAccount = {
	msisdn: string;
	subscriberCode?: string;
	cpnAccountNo?: string;
	shortCode?: string;
};

const model: types.models.InputModel = {
	msisdn: 'response.getCpnAccountResponse.cpnAccount.msisdn',
	subscriberCode: 'response.getCpnAccountResponse.cpnAccount.subscriberCode',
	cpnAccountNo: 'response.getCpnAccountResponse.cpnAccount.cpnAccountNo',
	shortCode: 'response.getCpnAccountResponse.cpnAccount.shortCode',
};

export default model;
